import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { adminApi } from '../services/api';

const VenueContext = createContext(null);

export function VenueProvider({ children }) {
  const [venues, setVenues] = useState([]);
  const [activeVenueId, setActiveVenueId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('active_venue_id');
    if (stored) setActiveVenueId(stored);

    adminApi.get('/admin/venues')
      .then(r => {
        const list = r.data.venues || [];
        setVenues(list);
        if (!stored && list.length > 0) {
          setActiveVenueId(list[0].id);
          localStorage.setItem('active_venue_id', list[0].id);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const switchVenue = useCallback((venueId) => {
    setActiveVenueId(venueId);
    localStorage.setItem('active_venue_id', venueId);
  }, []);

  const activeVenue = venues.find(v => v.id === activeVenueId) || venues[0] || null;

  const refreshVenues = useCallback(() => {
    return adminApi.get('/admin/venues')
      .then(r => { setVenues(r.data.venues || []); return r.data.venues; })
      .catch(() => []);
  }, []);

  return (
    <VenueContext.Provider value={{
      venues,
      activeVenueId,
      activeVenue,
      switchVenue,
      refreshVenues,
      loading,
      isMultiVenue: venues.length > 1,
    }}>
      {children}
    </VenueContext.Provider>
  );
}

export const useVenue = () => useContext(VenueContext);
